import styled from 'styled-components'

export const StyledContainer = styled.div`
  &.fade-enter {
    opacity: 0;
  }

  &.fade-enter-done {
    opacity: 1;
    transition: opacity 0.15s;
  }

  &.fade-exit {
    opacity: 1;
  }

  &.fade-exit-active {
    opacity: 0;
    transition: opacity 0.15s;
  }
`
